/* tslint:disable */

/**
 */
export class PackingElement {
    ID_PACKING_ELMT?: number;
    PACKING_VERSION?: number;
    PACKING_RELEASE?: number;
    PACKING_TYPE?: string;
    PACKING_COLOR?: string;
    PACKING_NAME?: string;
    USER_NAME?: string;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/packing-element.ts